/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getFile } from "actions";
import { APIURL } from "util/constant";

class Video extends Component {
  state = {
    // thumbnailFetched: false,
    // file: null,
  };

  componentDidMount() {
    // this.props.getFile(
    //   this.props.videoThumbnail,
    //   this.onBegin,
    //   this.onSuccess,
    //   this.onError
    // );
  }

  // onBegin = () => {
  //   this.props.onProcessBegin();
  // };

  // onError = (err) => {
  //   this.setState({ error: err.message });
  //   this.props.onProcessEnd();
  // };

  // onSuccess = (file) => {
  //   this.props.onProcessEnd();
  //   this.setState({
  //     thumbnailFetched: true,
  //     file: file,
  //   });
  // };

  render() {
    // if (this.state.thumbnailFetched) {
    return (
      <div
        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        onClick={this.props.onSelect}
      >
        <a href="#">
          <div className="imageSecVideoBg">
            <div className="sec-video-name">
              <span className="iconmford fo-icon-play-circle-outline"></span>
            </div>
            <div
              className="videoThumbImg"
              style={{
                //backgroundImage: `url(${this.state.file.binary})`,
                backgroundImage: `url(${APIURL}${this.props.videoThumbnail})`,
                position: "relative",
                zIndex: "-1",
              }}
            ></div>
          </div>
        </a>
        <div className="videoAreaTitle my-3">
          <span>{this.props.videoTitle}</span>
        </div>
        {/* <div className="videoAreaDesc">{this.props.videoDescription}</div> */}
      </div>
    );
    // } else {
    //   return this.props.spinner;
    // }
  }
}

// const mapStateToProps = (state, ownProps) => {
//   return {
//     file: state.files.find((f) => {
//       return f.id === ownProps.videoThumbnail;
//     }),
//   };
// };

export default connect(null, { getFile })(containsLongRunningProcess(Video));
